import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { usePermissionStore } from 'stores';
import { checkPermission } from 'Utils/permissions';
import { isFirstLogin, isUserLoggedSelector } from '../Redux/LoggedUserSlice';

export default function PrivateRoute({ component: Component, requiredPermission, ...rest }) {
  const isUserLogged = useSelector(isUserLoggedSelector);
  const isFirstTime = useSelector(isFirstLogin);
  const permissions = usePermissionStore(state => state.permissions);
  const permissionsLoaded = usePermissionStore(state => state.loaded);

  // 1. Manejar estado de carga: Si aún no se sabe si el usuario está logueado, no renderizar nada (o un spinner)
  if (isUserLogged === null) {
    return null; // O un componente de carga <LoadingSpinner />
  }

  return (
    <Route
      {...rest}
      render={props => {
        // 2. Si no está logueado, redirigir a Login
        if (!isUserLogged) {
          return <Redirect to="/login" />;
        }

        // 3. Si es el primer login y no está en la página de asignar contraseña, redirigir allí
        if (isFirstTime && props.location.pathname !== '/AssignPassword') {
          return <Redirect to="/AssignPassword" />;
        }

        // 4. Si NO es el primer login pero intenta acceder a la página de asignar contraseña, redirigir al dashboard
        if (!isFirstTime && props.location.pathname === '/AssignPassword') {
          return <Redirect to="/dashboard" />;
        }

        // 5. Si la ruta requiere un permiso específico, esperar a que el store
        // termine de hidratar antes de evaluar; sin esto, el array vacío del
        // estado inicial expulsaría a todo usuario antes de cargar los permisos.
        if (requiredPermission) {
          if (!permissionsLoaded) return null;
          if (!checkPermission(permissions, requiredPermission)) {
            return <Redirect to="/dashboard" />;
          }
        }

        // 6. Si está logueado y las condiciones anteriores no aplican, renderizar el componente de la ruta privada
        return <Component {...props} />;
      }}
    />
  );
}
